// extracted by mini-css-extract-plugin
module.exports =  {"frame":"a10a3f92e9--frame--sTly1"};